import type { UUID } from "@/core/types";

export const patientConsentsKeys = {
  base: ["consents"] as const,
  list: (id: UUID) => [...patientConsentsKeys.base, id] as const,
} as const;

export const policyMetadataKeys = {
  base: ["policyMetadata"] as const,
} as const;
